// CheckoutPage.jsx
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './CheckoutPage.module.css'; // Import the CSS module

const CheckoutPage = () => {
  const navigate = useNavigate();
  const { priceId } = useParams();

  useEffect(() => {
    const createCheckoutSession = async () => {
      try {
        const res = await fetch('https://377storage.vip/api/stripe/create-checkout-session', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ price_id: priceId }),
        });

        const contentType = res.headers.get('content-type');
        const text = await res.text();

        console.log("Raw response text:", text);
        console.log("Content-Type:", contentType);

        if (!res.ok) {
          throw new Error(`Request failed: ${res.status} - ${text}`);
        }

        if (!contentType || !contentType.includes('application/json')) {
          throw new Error('Expected JSON response, got something else.');
        }

        const data = JSON.parse(text);
        console.log("Parsed JSON:", data);
        console.log("checkout_url:", data.checkout_url);

        if (data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          throw new Error('No checkout_url in JSON');
        }
      } catch (error) {
        console.error('Checkout creation error:', error.message);
        return;
      }
    };

    createCheckoutSession();
  }, [navigate, priceId]);

  return (
    <div className={styles.container}>
      <p className={styles.message}>Redirecting to checkout...</p>
    </div>
  );
};

export default CheckoutPage;
